import React from 'react';
import { injectIntl } from 'react-intl';
import { Modal, Button } from 'semantic-ui-react';
import CloseIcon from '../../assets/add-ons/close.svg';
import { locale } from './locale';
import style from './styles-module.css';

const CancelModal = injectIntl(({
  cancelModalOpen,
  setCancelModalOpen,
  intl,
  history
}) => {
  const handleCancelChange = () => {
    history.push('/dashboard/add-ons');
    setCancelModalOpen(false);
  }

  return (
    <Modal
      open={cancelModalOpen}
      size="mini"
      onClose={() => setCancelModalOpen(false)}
      className={style.cancelationModal}
    >
      <Modal.Header>
        {intl.formatMessage(locale.cancelationModalHeader)}
        <div
          className={style.cancelModalClose}
          onClick={() => setCancelModalOpen(false)}
          role="button"
          tabIndex={0}
        >
          <CloseIcon />
        </div>
      </Modal.Header>
      <Modal.Content>
        {intl.formatMessage(locale.cancelationModalContent)}
      </Modal.Content>
      <Modal.Actions>
        <Button 
          onClick={() => setCancelModalOpen(false)}
          className={style.keepChanges}
        >
          {intl.formatMessage(locale.cancelationModalKeep)}
        </Button>
        <Button 
          onClick={handleCancelChange}
          className={style.cancelChanges}
        >
          {intl.formatMessage(locale.cancelationModalClose)}
        </Button>
      </Modal.Actions>
    </Modal>   
  );
});

export default CancelModal;
